// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import DbController from "./db_controller"
application.register("db", DbController)

import FroalaController from "./froala_controller"
application.register("froala", FroalaController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultiselController from "./multisel_controller"
application.register("multisel", MultiselController)

import OpenasController from "./openas_controller"
application.register("openas", OpenasController)

import RemovalsController from "./removals_controller"
application.register("removals", RemovalsController)

import Select2modalController from "./select2modal_controller"
application.register("select2modal", Select2modalController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import TimeagoController from "./timeago_controller"
application.register("timeago", TimeagoController)

import SubscribeController from "./subscribe_controller"
application.register("subscribe", SubscribeController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
